export function formatSsn(ssn: string) {
    if (ssn.length > 6) {
        ssn = ssn.replace('-', '');
        ssn = ssn.substring(0, 6) + '-' + ssn.substring(6, 10);
    }
    return ssn;
}

export function formatSsnToBasic(ssn: string) {
    return ssn.replace(/[-\s]/g, '');
}
